<button
  mat-raised-button
  [color]="color"
  [class.spinner]="loading"
  [disabled]="loading || disabled"
  [style.pointer-events]="loading || disabled ? 'none' : 'auto'"
>
  {{ name }}
</button>
